module.exports = __webpack_public_path__ + "static/media/browserconfig.xml"